import { render } from "./Power.vue?vue&type=template&id=2f15c84d"
import script from "./Power.vue?vue&type=script&lang=js"
export * from "./Power.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Gitlab-Runner\\builds\\bssYrz32\\0\\as\\WebServerVisualization\\webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__